// In seperate file for unit testing in Vite

export const getAuthTokens = () => ({
  authentication: window.cb?.core?.iam?.getAuthenticationToken(),
  authorization: window.cb?.core?.iam?.getAuthorizationToken(),
});
